import { Injectable, inject } from '@angular/core';
import {
  DetectionService,
  RenderService,
  SimulationService,
  TaskService,
} from '@services';
import '@tensorflow/tfjs-backend-webgl';
import { LigatingLoopMetricsService } from './ligating-loop-metrics.service';
import { SharedService } from './shared.service';

const WORKERS = {
  cycleWorker: {
    id: 'cycleWorker',
    model: 'default',
    historySize: 20,
    confidence: 0.2,
  },
  knotWorker: {
    id: 'knotWorker',
    model: 'loopInsideOutsideKnot',
    historySize: 20,
    confidence: 0.2,
  },
};

@Injectable({
  providedIn: 'root',
})
export class LigatingLoopRightService {
  private ligatingLoopMetricsService = inject(LigatingLoopMetricsService);
  private detectionService = inject(DetectionService);
  private renderService = inject(RenderService);
  private shared = inject(SharedService);
  private simulationService = inject(SimulationService);
  private taskService = inject(TaskService);

  constructor() {
    this.detectionService.addWorkers(WORKERS);
    this.shared.cycleWorkerId = WORKERS.cycleWorker.id;
    this.shared.knotWorkerId = WORKERS.knotWorker.id;
  }

  async runDetection() {
    if (this.simulationService.isSimulationRunning()) {
      await this.detectionService.detect(WORKERS.cycleWorker.id);
      await this.detectionService.detect(WORKERS.knotWorker.id);
      if (this.simulationService.state() === 'kit') {
        this.shared.checkSample();
      } else if (this.simulationService.state() === 'simulation') {
        this.shared.updateObjects();
        this.shared.toolTracking();
        switch (this.taskService.currentTaskId()) {
          case 'positionFoam': {
            this.shared.checkSample().then(async (isConfirmed) => {
              if (isConfirmed) {
                await this.renderService.waitForStaticCleanup();
                await this.taskService.completeTask('positionFoam');
              }
            });
            break;
          }
          case 'checkInstrument': {
            this.shared.checkInstrument().then(async (isConfirmed) => {
              if (isConfirmed) {
                await this.renderService.waitForStaticCleanup();
                await this.taskService.completeTask('checkInstrument');
              }
            });
            break;
          }
          case 'graspLeg': {
            this.shared.graspLeg().then(async (isConfirmed) => {
              if (isConfirmed) {
                await this.taskService.completeTask('graspLeg');
              }
            });
            break;
          }
          case 'tightenLoop': {
            this.shared.tightenLoop().then(async (isConfirmed) => {
              if (isConfirmed) {
                await this.taskService.completeTask('tightenLoop');
              }
            });
            break;
          }
          case 'cutThread': {
            if (!this.taskService.taskListCompleted()) {
              this.shared.cutThread().then(async (isConfirmed) => {
                if (isConfirmed) {
                  await this.taskService.completeTask('cutThread');
                }
              });
            }
            break;
          }
        }
      }
    }
  }
  stopDetection() {
    this.ligatingLoopMetricsService.finalizeMetrics();
    this.detectionService.terminateAllworkers();
  }
}
